import React from 'react';
import LazyLoad from 'react-lazyload';
import { string, shape } from 'prop-types';
import styles from './styles/styles.module.scss';

const ShopifyCard = ({ title, image, shopItemUrl, price }) => {
  return (
    <a className={styles.container} target="_blank" rel="noreferrer" href={shopItemUrl}>
      <div className={styles.imageContainer}>
        <LazyLoad>
          <img src={image.src} alt={image.altText} className={styles.image} />
        </LazyLoad>
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.price}>{price}</div>
    </a>
  );
};

ShopifyCard.propTypes = {
  title: string.isRequired,
  shopItemUrl: string.isRequired,
  image: shape({
    src: string.isRequired,
    altText: string
  }).isRequired,
  price: string.isRequired
};

export default ShopifyCard;
